import React, {useContext, useState, useEffect, useCallback} from "react";
import {useParams} from "react-router-dom";
import git from "isomorphic-git"

import {BackendContext} from "../../../context/BackendContext";
import {useGitDir} from "../../../hooks/useGitDir";
import { BranchDetailsRow } from "../../../components/Repo/BranchDetailsRow";
import { LoadingPageTransition } from "../../../components/App/LoadingPageTransition";
import styles from "./index.module.scss"

export const AllBranches: React.FC = () => {
  const {orbitId, repoId} = useParams()
  const {fs} = useContext(BackendContext)
  const gitDir = useGitDir(orbitId, repoId)
  const [branches, setBranches] = useState<string[]>([])

  const defaultBranch = "master"
  const getActiveBranches = useCallback(() => branches.filter((b) => b !== defaultBranch), [branches])

  useEffect(() => {
    if (!fs || !gitDir) {
      return
    }
    git.listBranches({fs, gitdir: gitDir}).then(
      branches => setBranches(branches.sort())
    )
  }, [fs, gitDir, setBranches])

  return fs && gitDir ? (
  <div className={styles.Container}>
    <h1 className={styles.Title}>All Branches</h1>
    <h2 className={styles.SubTitle}>Default</h2>
    <BranchDetailsRow fs={fs} gitDir={gitDir} branch={defaultBranch}/>
    <h2 className={styles.SubTitle}>Active branches</h2>
    {
      getActiveBranches().map((br => 
        <BranchDetailsRow fs={fs} gitDir={gitDir} branch={br} key={br} viewDetails/>
      ))
    }
  </div>
  ) :
  <LoadingPageTransition />
}